import './UmpireTopAndBottomPerformanceChart.scss';

import { UmpireTopAndBottomPerformanceChartConfigDto, UmpireTopAndBottomPerformanceChartDataDto } from 'types/CodegenReportTypes';
import { Typography } from '@trackman/web-shared-components';
import { t } from 'i18next';

import CoordinateSystem from 'components/Charts/CoordinateSystem/CoordinateSystem';
import { ChartProps } from 'utilities/chartIdToComponent';
import { orderedColorSets } from 'utilities/colorHelpers';
import Legend, { LegendItem } from 'components/Charts/Legend/Legend';

const UmpireAccuracyBar = ({ percentage, color }: { percentage: number; color: string }) => {
  return (
    <div
      className='UmpireAccuracyBar'
      style={{
        height: `${percentage}%`,
        backgroundColor: color,
      }}
    >
      <Typography className='UmpireAccuracyBar-value' variant='label'>
        {percentage.toFixed(1)}%
      </Typography>
    </div>
  );
};

const UmpireAverageAccuracy = ({ percentage }: { percentage: number }) => {
  return (
    <div
      className='UmpireAverageAccuracy'
      style={{
        bottom: `${percentage}%`,
      }}
    >
      <div className={'UmpireAverageAccuracy-textbox ' + (percentage > 50 ? 'place-below' : 'place-above')}>
        <Typography variant='label' component='div'>
          {t('Avg')}
        </Typography>
        <Typography variant='label bold' component='div'>
          {percentage.toFixed(1)}%
        </Typography>
      </div>
    </div>
  );
};

const legendItems: LegendItem[] = [
  {
    label: 'Highest',
    dotProps: { color: orderedColorSets[13].bg },
  },
  {
    label: 'Lowest',
    dotProps: { color: orderedColorSets[0].bg },
  },
  {
    label: 'Average',
    icon: <div style={{ width: '14px', border: '2px dashed #414141' }}></div>,
  },
];

const UmpireTopAndBottomPerformanceChart = ({
  chartData,
  isLoading,
  chartConfig,
}: ChartProps<UmpireTopAndBottomPerformanceChartDataDto, UmpireTopAndBottomPerformanceChartConfigDto>) => {
  const topUmpireNames = chartData?.topUmpires.map((umpire) => umpire.umpireName) ?? [];
  const bottomUmpireNames = chartData?.bottomUmpires.map((umpire) => umpire.umpireName) ?? [];
  const xTicks = [...topUmpireNames, ...bottomUmpireNames];

  return (
    <div className='UmpireTopAndBottomPerformanceChart'>
      <CoordinateSystem yLabel={t('Accuracy') + ' %'} xTicks={xTicks} yTicks={['0%', '20%', '40%', '60%', '80%', '100%']}>
        <div className='UmpireTopAndBottomPerformanceChart-bars'>
          {chartData?.topUmpires.map((umpire, i) => (
            <UmpireAccuracyBar key={umpire.umpireName} percentage={umpire.accuracy} color={orderedColorSets[13].bg} />
          ))}
          {chartData?.bottomUmpires.map((umpire, i) => (
            <UmpireAccuracyBar key={umpire.umpireName} percentage={umpire.accuracy} color={orderedColorSets[0].bg} />
          ))}
        </div>
        {chartData?.averageAccuracy && <UmpireAverageAccuracy percentage={chartData.averageAccuracy} />}
      </CoordinateSystem>
      <Legend items={legendItems} disableSorting={true} />
    </div>
  );
};

export default UmpireTopAndBottomPerformanceChart;
